import React from 'react';
import PropTypes from 'prop-types';

import { faArchive } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ArchiveDeviceModal from './ArchiveDeviceModal/ArchiveDeviceModal';
import { connectModalContainerContextToComponent } from '../../../contexts/ModalContext/ModalContext';

function ArchiveDeviceButton({ deviceId, deviceName, setModalJSX }) {
  const handleOpenArchiveDeviceModal = () => {
    setModalJSX(<ArchiveDeviceModal deviceId={deviceId} deviceName={deviceName} />);
  };

  return (
    <button
      type="button"
      className="btn btn-link"
      onClick={handleOpenArchiveDeviceModal}
      title="Archive"
    >
      <FontAwesomeIcon icon={faArchive} className="text-muted" />
    </button>
  );
}

ArchiveDeviceButton.propTypes = {
  deviceId: PropTypes.number.isRequired,
  deviceName: PropTypes.string.isRequired,
  setModalJSX: PropTypes.func.isRequired,
};

export default connectModalContainerContextToComponent(ArchiveDeviceButton);
